module.exports = __webpack_public_path__ + "img/alg_1.d6db5fcc.png";